import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import GroupCommunityPhotoUploadDetail from './GroupCommunityPhotoUploadDetail';
import BottomModal from 'components/presenters/modal/BottomModal';
import CommentBar from '../../../fixbar/CommentBar';
import server from 'server/serverController2';
import appInfoContainer from '../../../../auth/appInfoContainer';
import { useSelector, useStore } from 'react-redux';
import { ErrorStateActions } from 'store/actionCreators';
import DotButton from 'components/presenters/button/DotButton'
import { removeItem } from 'utils/utils';

// 하단 모달 창 리스트
let data = [
  { text: '핀 고정', color: '#ffa700', clickEvent: () => {} },
  { text: '글수정', color: '#4e4e4e' },
  { text: '삭제', color: '#4e4e4e' },
];

let replydata = [
  { text: '글수정', color: '#4e4e4e' },
  { text: '삭제', color: '#DE0000' },
];

export default function GroupCommunityComment({ match }) {
  const userInfo = useSelector((state) => {
    return state.userInfo;
  });
  const store = useStore();
  const history = useHistory();
  const inputRef = useRef(null);
  const scrollRef = useRef(null);
  // const insertedItemIndexes = [];// [1,2,3,4]
  // const insertedItemList = [];//[{no:1, content: "hello world" }]

  // const [showModal, setShowModal] = useState(false);
  // const [modalShow, setModalShow] = useState(false);
  const [callBackEvent, setCallBackEvent] = useState(null);
  const [replyUserName, setReplyUserName] = useState('');
  const [replycontent, setReplycontent] = useState('');
  const [currentPostIndex, setCurrentPostIndex] = useState(0);
  const [currentPostNo, setCurrentPostNo] = useState(0);
  const [lastNumber, setLastNumber] = useState(0)
  const [isLoading, setIsLoading] = useState(false);
  const [isEnd, setIsEnd] = useState(false);
  const [visible, setVisible] = useState(false);

  const [chatbar, setChatbar] = useState(false);
  const [isLikeAnimation, setIsLikeAnimation] = useState(false);
  const [currentComment, setCurrentComment] = useState({});
  const [insertedItemList, setInsertedItemList] = useState([]);
  const [insertedItemIndexes, setInsertedItemIndexes] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [communityDetail, setCommunityDetail] = useState([]);
  const [comments, setComments] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);
  
  const infoCallBack = async (jsonData) => {
    if (jsonData.success !== 1) {
      let state = store.getState();
      let errState = state['errorStateInfo'];
      let errFlag = errState['fetchErrTriggerd'];

      if (!errFlag && jsonData['error'] && jsonData['error']['res_data']) {
        await ErrorStateActions.setFetchErrState({ fetchErrTriggerd: true });
        let errData = jsonData['error']['res_data'];
        if (errData['detail_code'] === 'POST_DOES_NOT_EXIST') {
          alert('해당 게시글이 존재하지 않습니다.');
          history.push('/');
        } else {
          alert('예기치 못한 오류가 발생하였습니다.');
          history.push('/');
        }
      }
      return;
    }
    const resultData = jsonData.data.posts;
    setCurrentPostNo(resultData[0].no)
    setCommunityDetail(resultData);
  };
  const commCallBack = (jsonData) => {
    if (jsonData.success !== 1) {
      alert('예기치 못한 오류가 발생하였습니다.');
      return;
    }
    const resultData = jsonData.data.comments;
    const resultDataLength = resultData.length === 0 ? 0 : resultData[resultData.length - 1].no
    setLastNumber(resultDataLength);
    setComments(resultData);
  };

  const checkAdmin = (jsonData) => {
    if(jsonData['success'] !== 1) {
      alert('예기치 못한 오류가 발생하였습니다.');
      return;
    }
    const {role} = jsonData.data
    if(role === 'admin') setIsAdmin(true);
  }
  useEffect(() => {
    server.getRequestData(
      `groups/posts/${match.params.no}`,
      infoCallBack,
    );
    server.getRequestData(
      `groups/posts/${match.params.no}/comments?order=asc`,
      commCallBack,
    );
    server.getRequestData(`groups/${match.params.group_no}`, checkAdmin);
  }, []);

  // 댓글쓰기

  const callBack = (res) => {
    isclick = false;
    if (res.success === 1) {
      scrollRef.current.scrollTop = 0;
      const {inserted_item} = res.data;
      const communityDetailItem = communityDetail[0]
      if(inserted_item.post_no === communityDetailItem.no) {
        communityDetailItem.total_comment = parseInt(communityDetailItem.total_comment) + 1;
        setCommunityDetail([communityDetailItem]);
      }      
      inserted_item['profile_img'] = userInfo['profile_img'];
      inserted_item['nickname'] = userInfo['name']
      setInsertedItemIndexes([inserted_item.no, ...insertedItemIndexes]);
      setInsertedItemList([inserted_item, ...insertedItemList]);
      setReplycontent('');
    } else {
      alert('실패');
    }
  };
  /*--click block--*/
  var isclick = false;
  const submitCommentRequest = () => {
    if (isclick) return;
    isclick = true;
    setChatbar(false);
    if(replycontent.trim() === '') {
      inputRef.current.value = '';
      return;
    } 
    let data = {
      content: replycontent,
    };
    server.postRequestData(
      `groups/posts/${match.params.no}/comments`,
      JSON.stringify(data),
      callBack,
    );
  };

  // 좋아요 누르기
  const likecallBack = (res) => {
    isclick = false;
    if (res.success === 1) {
      setIsLikeAnimation(true);
      let list = [...communityDetail];
      list.map((value) => {
        if (value.no === res.data.inserted_item.post_no) {
          value.total_like = parseInt(value.total_like) + 1;
          value.liked_post = true;
        }
      });
      setTimeout(() => {
        setIsLikeAnimation(false);
      },1500)
      setCommunityDetail(list);
    } else {
      alert('실패');
    }
  };
  const likedataSubmit = (indexOptional) => {
    if (isclick) return;
    isclick = true;

    var postIndex = indexOptional ? indexOptional : currentPostIndex;
    let data = {};
    server.postRequestData(
      `groups/posts/${postIndex}/like`,
      JSON.stringify(data),
      likecallBack,
    );
  };

  // 좋아요 삭제
  const likedelcallBack = (res) => {
    isclick = false;
    if (res.success === 1) {
      let list = [...communityDetail];
      list.map((value) => {
        if (value.no === res.data.deleted_item[0].post_no) {
          value.total_like = parseInt(value.total_like) - 1;
          value.liked_post = false;
        }
      });
      setCommunityDetail(list);
    } else {
      alert('실패');
    }
  };
  const likedeldataSubmit = (indexOptional) => {
    var postIndex = indexOptional ? indexOptional : currentPostIndex;
    let data = {};
    server.deleteRequestData(
      `groups/posts/${postIndex}/like`,
      JSON.stringify(data),
      likedelcallBack,
    );
  };

  const handleUpdateComment = async() => {
    try {
      const body = {};
      body['content'] = replycontent;
      const jsonData = await server.putRequestData(`groups/posts/comments/${currentComment.no}`, body);
      if(jsonData.success === 0) {
       return; 
      };
      const {updated_item} = jsonData.data;
      const reloadCommentsList = comments.map((list) => {
        if(list.no === updated_item[0].no) {
          list['content'] = updated_item[0]['content'];
        }
        setReplycontent('');
        return list;
      })

      setComments(reloadCommentsList);
    } catch(err) {
      if(process.env.NODE_ENV === 'development') {
        console.log(err);
      }
    }
  }

  const deleteCommentRequest = async (param) => {
    try {
      const jsonData = await server.deleteRequestData(`groups/posts/comments/${param.no}`)
      if(jsonData['success'] === 0) {
        return;
      }
      const {deleted_item} = jsonData.data;
      if(insertedItemIndexes.includes(deleted_item[0].no)) {
        const index = insertedItemIndexes.indexOf(deleted_item[0].no);
        const reloadItemList = removeItem(insertedItemList, index);
        const reloadItemIndexes = removeItem(insertedItemIndexes, index);
        setInsertedItemIndexes(reloadItemIndexes);
        setInsertedItemList(reloadItemList);
      }
      const reloadComments = comments.filter((list) => {
        return deleted_item[0].no !== list.no;
      })
      const communityDetailItem = communityDetail[0]
      if(deleted_item[0].post_no === communityDetailItem.no) {
        communityDetailItem.total_comment = parseInt(communityDetailItem.total_comment) - 1;
        setCommunityDetail([communityDetailItem]);
      }
      setComments(reloadComments);
      setVisible(false);
    } catch (error) {
      if(process.env.NODE_ENV === 'development') {
        console.log(error);
      }
    }
  } 

  const handleModal = (e, currentValue) => {
    if(!currentValue) {
      setVisible(false);
      return;
    }
    setCurrentComment(currentValue);
    setDataList([{type: 'callback', text: '삭제', callback: deleteCommentRequest, callbackParam: currentValue ,style: {color: '#DE0000'}}]);
    setVisible(true);
  }

  const handleScroll = (e) => {
    if(!isLoading && !isEnd) 
    {
      const bottom = e.target.scrollHeight - e.target.scrollTop - 100 <= e.target.clientHeight;
      if(bottom) {
        setIsLoading(true);
        server.getRequestData(`groups/posts/${match.params.no}/comments?order=asc&last_pos_no=${lastNumber}`,
        (res) => {
          if(res.success !== 1 || res.data.comments.length === 0) {
            setIsEnd(true);
            setIsLoading(false);
            return;
          }
          const comments = res.data.comments;
          setLastNumber(comments[comments.length - 1].length === 0 ? 0 : comments[comments.length - 1].no);
          setComments(list => {
            return list.concat(comments)});
          setIsLoading(false);
        })
      }
    }
  }
  
  return (
    <CummunityCommentInner onScroll={(e) => handleScroll(e)} ref={scrollRef}>
      {communityDetail.map((value) => {
        return (
          <GroupCommunityPhotoUploadDetail
            key={`community-post-${value.no}-images `}
            path={true}
            borderwidth={'calc(100vw*(1/375)) 0'}
            borderline={'solid #eaeaea'}
            margintop={'calc(100vw*(16.5/375))'}
            setModalShow={() => {}}
            item={value}
            userInfo={userInfo}
            likedataSubmit={likedataSubmit}
            likedeldataSubmit={likedeldataSubmit}
            isLikeAnimation={isLikeAnimation}
            currentPostNo={currentPostNo}
            isAdmin={isAdmin}
            setCommunityDetail={setCommunityDetail}
          />
        );
      })}
      <CummunityCommentArea>
        {insertedItemList ? insertedItemList.map((value) => {
          return <CommentUserList key={`group-community-comment-item-${value.no}`} value={value} userInfo={userInfo} handleModal={handleModal} backgroundColor={'#f7f7f7'}/>
        }) : null}
        {comments.map((value) => {
          if(insertedItemIndexes.includes(value.no)) return null;
          return <CommentUserList key={`group-community-comment-item-${value.no}`} value={value}  userInfo={userInfo} handleModal={handleModal}/>;
        })}
      </CummunityCommentArea>
      <Spacer />
      <CommentBar
        nickname={replyUserName}
        chatbar={chatbar}
        setChatbar={setChatbar}
        setReplycontent={setReplycontent}
        replycontent={replycontent}
        inputRef={inputRef}
        handleUpdateComment={handleUpdateComment}
        submitCommentRequest={submitCommentRequest}
      />
      <BottomModal visible={visible} setVisible={setVisible} dataList={dataList}/>
    </CummunityCommentInner>
  );
}

function CommentUserList({ value, userInfo, setReplyUserName, handleModal, backgroundColor}) {
  const today = new Date();
  const timeValue = new Date(value.create_date);
  const betweenTimeS = Math.floor(
    (today.getTime() - timeValue.getTime()) / 1000,
  );
  const betweenTimeM = Math.floor(
    (today.getTime() - timeValue.getTime()) / 1000 / 60,
  );
  const betweenTimeHour = Math.floor(betweenTimeM / 60);
  const betweenTimeDay = Math.floor(betweenTimeM / 60 / 24);

  const CommentTime = () => {
    if(betweenTimeS < 0) {
      return `0s`;
    }
    if (betweenTimeS < 60) {
      return `${betweenTimeS}s`;
    } else if (betweenTimeM < 60) {
      return `${betweenTimeM}m`;
    } else if (betweenTimeHour < 24) {
      return `${betweenTimeHour}h`;
    } else if (betweenTimeDay < 365) {
      return `${betweenTimeDay}d`;
    } else {
      return `${Math.floor(betweenTimeDay / 365)}y`;
    }
  };
  
  return (
    <div>
      <CummunityCommentText style={{background: backgroundColor}}>
        <UserImg>
          <Images
            src={
              appInfoContainer.imagePath +
              '/user_profile_img/' +
              value.profile_img
            }
          />
        </UserImg>
        <CummunityCommentTextList>
          <li>
            <Name>{value.nickname}</Name>
            <CommentTxt>{value.content}</CommentTxt>
          </li>
          <li>
            <CommTime>{CommentTime()}</CommTime>
          </li>
          {value.user_no === userInfo.id ? 
          <DotButtonarea>
            <DotButton onClick={(e) => handleModal(e, value)} style={{marginLeft: 'calc(100vw * (15 / 375))'}}/>
          </DotButtonarea> : null}
        </CummunityCommentTextList>
      </CummunityCommentText>
    </div>
  );
}

const Images = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
const CummunityCommentInner = styled.div`
  padding: 0 calc(100vw * (5 / 375)) calc(100vw * (69 / 375)) calc(100vw * (7 / 375));
  overflow-y: scroll;
  height: 100%;
  `;
const CummunityCommentArea = styled.div`
  // padding: calc(100vw * (8.5 / 375)) calc(100vw * (16 / 375)) calc(100vw * (33 / 375));
`;
const CummunityCommentText = styled.div`
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
`;
const CummunityCommentTextList = styled.ul`
  position: relative;
  margin-left: calc(100vw * (6 / 375));
  margin-top: calc(100vw * (11 / 375));
  // margin-bottom: calc(100vw * (11 / 375));
  width: calc(100vw * (300 / 375));
`;
const UserImg = styled.div`
  width: calc(100vw * (28 / 375));
  height: calc(100vw * (28 / 375));
  border-radius: 50%;
  overflow: hidden;
  border: solid calc(100vw * (1 / 375)) #c6c6c6;
  margin-bottom: calc(100vw * (5 / 375));
`;
const CommentTxt = styled.span`
  white-space: pre-wrap;
  font-size: calc(100vw * (14 / 375));
  color: #1d1d1d;
  word-break:break-all;
`;
const Name = styled.a`
  font-size: calc(100vw * (14 / 375));
  color: #1d1d1d;
  font-weight: 500;
  margin-right: calc(100vw * (5 / 375));
`;
const CommTime = styled.span`
  font-size: calc(100vw * (11 / 375));
  line-height: 1.55;
  color: #989898;
`;

const DotButtonarea = styled.li`
  position: absolute;
  top: 0;
  right: 0;
  width: 20px;
  padding: calc(100vw * (8.5 / 375));
`

const Spacer = styled.div`
  height: calc(100vw*(150/375));
`;